import request from '@/utils/http';
import utils from '@/utils/common';
const apiCrmHost = 'api-lcrm';

// 线索引入列表
export const getLeadList = (data) => {
    return request({
        url: apiCrmHost + '/lead/list',
        method: 'post',
        data
    });
};

// 线索引入详情
export const getLeadDetail = (data) => {
    return request({
        url: apiCrmHost + `/lead/detail/${data.id}`,
        method: 'get',
        data
    });
};

// 线索引入-生成线索
export const getLeadGenerate = (data) => {
    return request({
        url: apiCrmHost + '/lead/generate',
        method: 'post',
        data
    });
};

// 线索引入-导入
export const importLead = (data) => {
    return request({
        url: apiCrmHost + '/lead/import',
        method: 'post',
        data
    });
};

// 线索引入-导出
export const exportLead = (data) => {
    return request({
        url: apiCrmHost + '/lead/export',
        method: 'post',
        data
    });
};

// 线索引入-废弃
export const getLeadDiscard = (data) => {
    return request({
        url: apiCrmHost + '/lead/discard',
        method: 'post',
        data
    });
};

// 线索导入-下载导入模版
export const importTemplate = (params) => {
    return request({
        url: apiCrmHost + '/lead/importTemplate',
        method: 'get',
        responseType: 'blob',
        params
    }).then((res) => {
        utils.downloadStream(res, params.fileName);
    });
};

// 查询是否特权人

export const getAdminRole = (params) => {
    return request({
        url: apiCrmHost + '/lead/getAdminRole',
        method: 'get',
        params
    });
};
